interface LegalSection {
  title?: string;
  paragraphs: string[];
}

interface LegalContentProps {
  sections: LegalSection[];
}

export const LegalContent = ({ sections }: LegalContentProps) => {
  return (
    <div className="space-y-6">
      {sections.map((section, index) => (
        <section key={index}>
          {section.title && (
            <h2 className="text-lg font-semibold text-primary mb-3">{section.title}</h2>
          )}
          <div className="space-y-2">
            {section.paragraphs.map((paragraph, pIndex) => (
              <p key={pIndex} className="text-sm text-text leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};
